import {retry} from '../../../../utills/retryHelper'
import {AdyenShippingMethodsService} from '../services/shipping-methods'
import {CustomApiClient} from '../webhook/customApi'
import Logger from '../webhook/logger'
import {ORDER, PAYMENT_METHODS} from './constants.mjs'

export async function handleOrderStatus(orderNo, kountStatus, orderApi, checkoutResponse) {
    if (checkoutResponse.isFinal && kountStatus) {
        try {
            var kountStausLogMessage = `Kount-${kountStatus}`
            if (kountStatus === 'APPROVED' && checkoutResponse.isSuccessful) {
                await retry(
                    () => orderApi.updateOrderExportStatus(orderNo, ORDER.EXPORT_STATUS_READY),
                    orderNo,
                    `${kountStausLogMessage}-updateOrderExportStatus`
                )
                await retry(
                    () =>
                        orderApi.updateOrderConfirmationStatus(
                            orderNo,
                            ORDER.CONFIRMATION_STATUS_CONFIRMED
                        ),
                    orderNo,
                    `${kountStausLogMessage}-updateOrderConfirmationStatus`
                )
                await retry(
                    () => orderApi.updateOrderStatus(orderNo, ORDER.ORDER_STATUS_NEW),
                    orderNo,
                    `${kountStausLogMessage}-updateOrderStatus`
                )
            } else if (kountStatus !== 'HOLD' || !checkoutResponse.isSuccessful) {
                await retry(
                    () => orderApi.updateOrderStatus(orderNo, ORDER.ORDER_STATUS_FAILED),
                    orderNo,
                    `${kountStausLogMessage}-updateOrderExportStatus`
                )
                await retry(
                    () =>
                        orderApi.updateOrderExportStatus(orderNo, ORDER.EXPORT_STATUS_NOT_EXPORTED),
                    orderNo,
                    `${kountStausLogMessage}-updateOrderExportStatus`
                )
                await retry(
                    () =>
                        orderApi.updateOrderConfirmationStatus(
                            orderNo,
                            ORDER.CONFIRMATION_STATUS_NOT_CONFIRMED
                        ),
                    orderNo,
                    `${kountStausLogMessage}-updateOrderConfirmationStatus`
                )
            }
        } catch (e) {
            Logger.error(
                `Error occurred while updating order status for order number: ${orderNo}, error: ${JSON.stringify(
                    e
                )}`
            )
        }
    }
}

export const createPaymentInstrumentWithResourceState = async (
    shopperOrders,
    orderNo,
    body,
    operationName
) => {
    try {
        return await retry(
            () =>
                shopperOrders.createPaymentInstrumentForOrder({
                    parameters: {
                        orderNo
                    },
                    body
                }),
            orderNo,
            operationName
        )
    } catch (error) {
        Logger.error(
            `${operationName}: Failed after 3 attempts, and the error was - ${JSON.stringify(
                error
            )}`
        )
        if (operationName === 'adyenLogUpdateResponse') {
            const customApiClient = new CustomApiClient()
            await customApiClient.createAdyenNotification(orderNo, body.c_Adyen_log)
        }
    }
}

export const syncOrderPaymentData = async (shopperOrders, orderNo, paymentResponse) => {
    Logger.error('starting createPaymentInstrumentForOrder for adyen log update')

    let adyenLogUpdateResponse = await createPaymentInstrumentWithResourceState(
        shopperOrders,
        orderNo,
        {
            paymentMethodId: 'ADYEN_CUSTOM_SESSION',
            c_Adyen_log: JSON.stringify(paymentResponse)
        },
        'adyenLogUpdateResponse'
    )
    Logger.error('completed createPaymentInstrumentForOrder for adyen log update')
    if (!adyenLogUpdateResponse?.orderNo) {
        Logger.error('adyenLogUpdateResponse', adyenLogUpdateResponse)
    }

    Logger.error('starting createPaymentInstrumentForOrder for post risk')

    let postRiskResponse = await createPaymentInstrumentWithResourceState(
        shopperOrders,
        orderNo,
        {
            paymentMethodId: 'ADYEN_CUSTOM_SESSION',
            c_isPreRisk: false
        },
        'postRiskResponse'
    )
    Logger.error('completed createPaymentInstrumentForOrder for post risk')

    if (!postRiskResponse?.orderNo) {
        Logger.error('postRiskResponse', postRiskResponse)
    }
    return postRiskResponse
}

export const removeAllPaymentInstrumentsFromBasket = async (basket, shopperBaskets) => {
    const promises = []
    if (basket?.paymentInstruments?.length) {
        basket?.paymentInstruments.forEach((paymentInstrument) => {
            Logger.info('paymentInstrument', paymentInstrument)

            if (paymentInstrument.paymentMethodId === PAYMENT_METHODS.ADYEN_COMPONENT) {
                const promise = shopperBaskets.removePaymentInstrumentFromBasket({
                    parameters: {
                        basketId: basket.basketId,
                        paymentInstrumentId: paymentInstrument.paymentInstrumentId
                    }
                })
                promises.push(promise)
            }
        })
    }
    return Promise.all(promises)
}

export const retainBasket = async (shopperBaskets, shopperOrders, order, req) => {
    if (order?.orderNo) {
        await createPaymentInstrumentWithResourceState(
            shopperOrders,
            order.orderNo,
            {
                paymentMethodId: 'ADYEN_CUSTOM_SESSION',
                c_retainOrder: true
            },
            'retainOrder'
        )
    }
    const basket = await shopperBaskets.getBasket({
        parameters: {
            basketId: order?.c_basketRefId
        }
    })

    if (basket?.paymentInstruments?.length) {
        Logger.info('removeAllPaymentInstrumentsFromBasket')
        await removeAllPaymentInstrumentsFromBasket(basket, shopperBaskets)
    }
}
export const fetchShippingMethods = async (basketId, site, authToken) => {
    const adyenShippingMethodsService = new AdyenShippingMethodsService(authToken, site)
    try {
        return await adyenShippingMethodsService.getShippingMethods(basketId)
    } catch (error) {
        return null
    }
}
